__webpack_require__.p = "/_ui/g-star/js/";